<button [ngClass]="{'flip': flip==true, 'rotate': rotate==true}">
  <img [src]="flip ?  './assets/images/button-navigation-flipped.png': './assets/images/button-navigation.png'">
  <h1>{{title}}</h1>
</button>
